import { MessageSquareQuote, Star } from "lucide-react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";
import { openPreRegister } from "@/lib/preRegisterModal";

// Honest empty-state — RelayRigs is pre-launch, so there are no real reviews yet.
// This holds the spot for genuine driver/carrier reviews once the platform is live.
export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-rr-surface overflow-hidden">
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
      <SectionHeading
        eyebrow="Reviews & Feedback"
        title="Real Stories, Coming Soon"
        testId="testimonials"
      />
      <Reveal delay={0.1}>
        <div
          data-testid="reviews-empty-state"
          className="mt-10 border-2 border-dashed border-rr-line rounded-[2rem] p-10 md:p-14 bg-white/60"
        >
          <div className="flex gap-1 justify-center mb-5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={`star-${i}`} size={18} className="text-rr-line" />
            ))}
          </div>
          <MessageSquareQuote size={32} className="text-rr-orange/50 mx-auto mb-4" />
          <p className="font-heading text-xl md:text-2xl text-rr-navy leading-snug">
            No reviews yet — RelayRigs hasn't launched.
          </p>
          <p className="text-rr-muted mt-3 max-w-md mx-auto leading-relaxed">
            We're keeping this spot open for real feedback from drivers, owner-operators, and carriers once the marketplace goes live. No stock quotes, no stand-ins.
          </p>
          <button
            onClick={() => openPreRegister("driver")}
            data-testid="reviews-empty-state-cta"
            className="mt-7 inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-7 py-3.5 rounded-full hover:bg-rr-navy transition-all hover:-translate-y-0.5"
          >
            Be First to Leave a Review
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
